import { useState, useEffect } from "react";
import Txn from "./Txn";
import { transactionAPI, accountAPI } from "services";
import useUniversalStore from "store/universalStore";
import {
  Loader,
  ReminderAlert,
  OpenCloseBalance,
  ListHeader
} from "components";
import { formatMoney } from "utils";

const TxnsListView = ({ monthlyDate, animation, setAnimation, hideClosed }) => {
  const txns = useUniversalStore((state) => state.transactions);
  const accountId = useUniversalStore((state) => state.accountId);
  const [loading, setLoading] = useState(false);
  const [openBalance, setOpenBalance] = useState(0);
  const [closeBalance, setCloseBalance] = useState(0);
  const [loader, setLoader] = useState(false);
  const [filteredTnx, setFilteredTnx] = useState(txns);
  const [monthlyCash, setMonthlyCash] = useState({
    in: 0,
    out: 0
  });

  //const [showReminder, setShowReminder] = useState(false);

  //TODO : optimize it and move to relevant component.
  // const overDue =
  //   currentDate >= account?.get("date") && account?.get("enabled");

  useEffect(() => {
    if (hideClosed) {
      const filtered = txns.filter((item) => !item.get("cancelled"));
      setFilteredTnx(filtered);
    } else {
      setFilteredTnx(txns);
    }
  }, [hideClosed, txns])

  const loadData = async () => {
    setLoading(true);
    await calculateOpeningClosingBalance();
    await monthlyCashInOut();
    setLoading(false);
  }

  useEffect(() => {
    loadData();
  }, [monthlyDate, filteredTnx, accountId]);

  const calculateOpeningClosingBalance = async () => {
    //Fetching Opening Balance
    const startDate = new Date(monthlyDate.getFullYear(), monthlyDate.getMonth(),
      1, 0, 0, 0, 0);
    setOpenBalance(await transactionAPI.sumTillDateByAccount(startDate, accountId));

    //Fetching Closing Balance
    const endDate = new Date(monthlyDate.getFullYear(), monthlyDate.getMonth() + 1,
      0, 23, 59, 59, 999);
    setCloseBalance(await transactionAPI.sumTillDateByAccount(endDate, accountId));
  }

  const monthlyCashInOut = async () => {
    transactionAPI.monthlyCashInOut(accountId, monthlyDate, "in")
      .then((res) => {
        setMonthlyCash({
          ...monthlyCash,
          in: formatMoney(Math.abs(res))
        });
      });
    transactionAPI.monthlyCashInOut(accountId, monthlyDate, "out")
      .then((res) => {
        setMonthlyCash({
          ...monthlyCash,
          out: formatMoney(Math.abs(res))
        });
      });
  }
  // useEffect(() => {
  //   if (overDue) {
  //     setShowReminder((prev) => true);
  //   } else {
  //     setShowReminder((prev) => false);
  //   }
  // }, [overDue]);

  // ${showReminder ? "opacity-25" : ""}

  return (
    <div
      className={`background mb-auto pb-5 slide ${animation}`}
      onAnimationEnd={() => setAnimation("")}>
      {loading ? <Loader /> : <div className="row">
        <div className="col-md-6 list-group list-group-flush overflow-scroll scrollbar-design h-100"
          style={{ height: 'calc(100vh - 250px)', maxHeight: 'calc(100vh - 250px)' }}>
          <ListHeader type="in" amount={monthlyCash.in} />
          <OpenCloseBalance type="open" sum={openBalance} />
          {filteredTnx?.filter((txn) => txn.get("amount") > 0)
            ?.filter((txn) => !txn.cancelled)
            ?.map((txn, i) => <Txn data={txn} key={i} setLoader={setLoader} monthlyDate={monthlyDate} />)}
        </div>
        <div className="col-md-6 list-group list-group-flush overflow-scroll scrollbar-design h-100"
          style={{ height: 'calc(100vh - 250px)', maxHeight: 'calc(100vh - 250px)' }}>
          <ListHeader type="out" amount={monthlyCash.out} />
          {filteredTnx?.filter((txn) => txn.get("amount") < 0)
            ?.filter((txn) => !txn.cancelled)
            ?.map((txn, i) => <Txn data={txn} key={i} setLoader={setLoader} monthlyDate={monthlyDate} />)}
          <OpenCloseBalance type="close" sum={closeBalance} />
        </div>
      </div>}

      {/* <ReminderAlert
            currentUser={currentUser}
            account={accountId}
            accountId={accountId}
            setShowReminder={setShowReminder}
            showReminder={showReminder}
          /> */}

    </div>
  );
};

export default TxnsListView;